import { haloRequest } from '../../utils/haloRequest';

export async function getNftDetail(params) {
  return haloRequest({
    url: '/nft/my_nft',
    method: 'get',
    params: {
      ...params
    }
  })
}

export async function getNftList(params) {
  return haloRequest({
    url: '/nft/nfts_online_paged',
    method: 'get',
    params: {
      ...params
    }
  })
}